import React from 'react';
import { ChatContent } from './ChatContent';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';

export function Chat() {
    return <ChatContent />;
}

export default withRouter(Chat);
